import { toArray } from '@m1/geo-utils';
import OlMap, { MAX_ZOOM } from '@m1/ol-map';
import classNames from 'classnames/bind';
import React from 'react';
import { RiFullscreenLine, RiZoomOutLine, RiZoomInLine, RiCrosshairLine, RiScreenshot2Line } from 'react-icons/ri';
import { useDispatch, useSelector, useStore } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import Bar from '@/components/ui/Bar';
import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import telemetryStore from '@/stores/telemetryStore';
import { getCSSVariable } from '@/utils/theme';

const cx = classNames.bind(styles);

const MapTool = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const zoom = useSelector((state) => state.map.zoom);
  const isShowShoots = useSelector((state) => state.map.isShowShoots);

  const toggleShoots = () => {
    dispatch(actions.map.toggleShoots());
  };

  const fitBounds = () => {
    const { mission, missions, robots } = store.getState();

    const positionsFromCommands = getPositions(mission.json.commands);
    const positionsFromMissions = missions.flatMap(({ path }) => path.map(({ position }) => toArray(position)));
    const positionsFromRobots = robots
      .filter(({ isShow }) => isShow)
      .filter(({ id }) => telemetryStore.get(id, MESSAGE.GLOBAL_POSITION_INT))
      .map(({ id }) => {
        const { lat, lng } = telemetryStore.get(id, MESSAGE.GLOBAL_POSITION_INT);
        return [lng, lat];
      });

    OlMap.fitBounds([...positionsFromCommands, ...positionsFromMissions, ...positionsFromRobots]);
  };

  const getPositions = (commands) => {
    const positions = [];
    commands.forEach(({ type, data }) => {
      switch (type) {
        case 'doSetRoiLocation':
        case 'navLand':
        case 'navLoiterTime':
        case 'navLoiterToAlt':
        case 'navLoiterTurns':
        case 'navTakeoff':
        case 'navWaypoint':
          positions.push([data.position.lng, data.position.lat]);
          break;

        case 'cusSurvey':
          data.positions.forEach(({ lat, lng }) => positions.push([lng, lat]));
          break;

        default:
          break;
      }
    });
    return positions;
  };

  const zoomOut = () => {
    const view = OlMap.getMap().getView();
    view.animate({
      zoom: view.getZoom() - 1,
      duration: 300,
    });
  };

  const zoomIn = () => {
    const view = OlMap.getMap().getView();
    view.animate({
      zoom: view.getZoom() + 1,
      duration: 300,
    });
  };

  const moveToCurrent = () => {
    window.navigator.geolocation.getCurrentPosition(({ coords }) => {
      OlMap.getMap().getView().setZoom(MAX_ZOOM);
      OlMap.setCenter({ lng: coords.longitude, lat: coords.latitude });
    });
  };

  return (
    <>
      <div className={cx('group')}>
        <div className={cx('button')} onClick={toggleShoots}>
          <RiScreenshot2Line
            size={20}
            title={isShowShoots ? 'Hide Shoots' : 'Show Shoots'}
            color={isShowShoots ? getCSSVariable('--tint-color') : 'white'}
          />
        </div>
        <div className={cx('button')} onClick={fitBounds}>
          <RiFullscreenLine size={20} title="Fit Bounds" color="white" />
        </div>
        <div className={cx('button')} onClick={moveToCurrent}>
          <RiCrosshairLine size={20} title="Current Location" color="white" />
        </div>
      </div>
      <Bar size={24} horizontal />
      <div className={cx('group')}>
        <div className={cx('zoom')}>{Math.round(zoom)}</div>
        <div className={cx('button')} onClick={zoomOut}>
          <RiZoomOutLine size={20} title="Zoom Out" color="white" />
        </div>
        <div className={cx('button')} onClick={zoomIn}>
          <RiZoomInLine size={20} title="Zoom In" color="white" />
        </div>
      </div>
    </>
  );
};

export default MapTool;
